export default __webpack_public_path__ + "static/media/01_tag_free-wifi.3c24c00f.svg";